module.exports = __webpack_public_path__ + "static/media/40.0d67fa6f.jpg";